import styled from 'styled-components';

export const AvailableItemMaskContainer = styled.div`
  width: calc(100% - 10px);
  display: flex;
  align-items: center;
  background: 'transparent';
  min-height: 35px;
  padding: 0 5px;
`;

export const AvailableItemMaskLabel = styled.div`
  cursor: pointer;
`;
